import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "../../lib/utils";

const SwitchLabel = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    labelValue?: number[] | string[];
    classNameThumb?: string;
  }
>(({ className, checked, labelValue, classNameThumb, ...props }, ref) => {
  const [firstValue, seconValue] = labelValue || ["", ""];
  return (
    <SwitchPrimitives.Root
      className={cn(
        "relative shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus:bg-none disabled:opacity-50 bg-neutral-100 active:bg-none text-body-small",
        className
      )}
      checked={checked}
      {...props}
      ref={ref}
    >
      <div className="absolute h-full w-full z-10 flex justify-center items-center text-neutral-500">
        <div className="flex-1">{firstValue}</div>
        <div className="flex-1">{seconValue}</div>
      </div>
      <SwitchPrimitives.Thumb
        className={cn(
          "relative z-20 flex items-center justify-center pointer-events-none h-full w-1/2 bg-eraRed-600 shadow-lg ring-0 transition-transform data-[state=checked]:bg-[eraRed-600] data-[state=checked]:translate-x-[100%] rounded-3xl data-[state=unchecked]:translate-x-0 text-white",
          classNameThumb
        )}
      >
        {checked ? seconValue : firstValue}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  );
});
SwitchLabel.displayName = SwitchPrimitives.Root.displayName;

export { SwitchLabel };
